<label>{{label}}:</label>
<div class="chunk-progress-bar">
	<div [class.active]="percentValue > 0"  class="progress-chunk chunk-25"></div>
	<div [class.active]="percentValue > 25" class="progress-chunk chunk-50"></div>
	<div [class.active]="percentValue > 50" class="progress-chunk chunk-75"></div>
	<div [class.active]="percentValue > 75" class="progress-chunk chunk-100"></div>
</div> 
